import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

/* Prime */

/* Útiles */

/* Componentes base */

/* Componentes */
import { HomeComponent } from './components/home/home.component';
import { AplicativosComponent } from './components/aplicativos/aplicativos.component';
import { CardModule } from 'primeng/card';
import {ButtonModule} from 'primeng/button';
import {RouterModule} from '@angular/router';
@NgModule({
    declarations: [
        HomeComponent,
        AplicativosComponent,
    ],
    imports: [
        RouterModule,
        ButtonModule,
        CardModule,
        CommonModule,
        HttpClientModule,
    ],
    providers: [],
})
export class ProyectoModule {}
